console.log("Environment test:", {
  NODE_ENV: process.env.NODE_ENV,
  REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  isDevelopment: process.env.NODE_ENV === "development",
});
